var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShopGlobalMenuIcon = function SvgShopGlobalMenuIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4985 16.1237L10.8105 10.2717C10.6302 10.114 10.3634 10.1063 10.1743 10.2533L2.6503 16.1053C2.27451 16.3976 2.48119 17 2.95727 17H17.1693C17.631 17 17.846 16.4277 17.4985 16.1237Z",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03943 5.01914C8.15997 4.56929 8.42728 4.17257 8.79895 3.89194C9.17062 3.6113 9.62536 3.46282 10.091 3.47005C10.5567 3.47729 11.0066 3.63982 11.3694 3.93186C11.7322 4.2239 11.987 4.62872 12.0935 5.0821C12.2 5.53548 12.1521 6.01144 11.9573 6.43447C11.7625 6.8575 11.432 7.20337 11.0183 7.41719C10.6046 7.63102 10.1313 7.70055 9.67354 7.61477",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
export default SvgShopGlobalMenuIcon;